import React from 'react';
import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Dashboard from './Dashboard';
import RepScorecards from './RepScorecards/RepScorecards';
import NewPhysician from './NewPhysician/NewPhysician';
import TopMedications from './TopMedications/TopMedications';
import TopCities from './TopCities/TopCities';
import TopStates from './TopStates/TopStates';
import TopSpecializations from './TopSpecializations/TopSpecializations';
import TopPayors from './TopPayors/TopPayors';
import TopGroups from './TopGroups/TopGroups';
import TopPhysicians from './TopPhysicians/TopPhysicians';
import TopCopayNetworks from './TopCopayNetworks/TopCopayNetworks';
import GrowthBySpecializations from './GrowthBySpecializations/GrowthBySpecializations';
import TopHubs from './TopHubs/TopHubs';
import ReportSingle from './ReportSingle';
import SyncPakVsSortPak from './SyncPakVsSortPak/SyncPakVsSortPak';
import NoteCount from './NoteCount/NoteCount';
import UnassignedPhysicians from './UnassignedPhysicians/UnassignedPhysicians';
import RepBonus from './RepBonus/RepBonus';
import TopPhysiciansByRevenue from './TopPhysiciansByRevenue/TopPhysiciansByRevenue';
import Invoices from './Invoices/Invoices';
import PhysicianMedicationReport from './PhysicianMedicationReport/PhysicianMedicationReport';
import RevenueGrowthVSLastMonth from './RevenueGrowth/RevenueGrowthVSLastMonth';
import RevenueGrowthVSLastYear from './RevenueGrowth/RevenueGrowthVSLastYear';
import ScriptWorkflow from './RepScorecards/ScriptWorkflow';
import CelmodReport from './CelmodReport/CelmodReport';
import DashboardKPI from './DashboardKPI/DashboardKPI';
import DashboardPatientAdherence from './DashboardKPI/DashboardPatientAdherence';
import AutoRefillData from './AutoRefillData/AutoRefillData';
import DashboardPatients from './DashboardPatients/DashboardPatients';
import Pipeline from '../Health/Pipeline/Pipeline';
import PipelineReports from '../Health/Pipeline/PipelineReports/PipelineReports';

export const DashboardRoutes = (
  <Route path="dashboard" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health', 'Manufacturer Users']}>
          <Dashboard />
        </PrivateRoute>
        )}
    />

    <Route
      path="pdc-statistics"
      element={(
        <PrivateRoute roles={['Admin', 'Health']}>
          <DashboardKPI />
        </PrivateRoute>
        )}
    />

    <Route
      path="patient-adherence"
      element={(
        <PrivateRoute roles={['Admin', 'Health']}>
          <DashboardPatientAdherence />
        </PrivateRoute>
        )}
    />

    <Route
      path="rep-scorecards"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <RepScorecards />
        </PrivateRoute>
        )}
    />

    <Route
      path="rep-bonus"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <RepBonus />
        </PrivateRoute>
        )}
    />

    <Route
      path="invoices"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <Invoices />
        </PrivateRoute>
        )}
    />

    <Route
      path="user-workflow"
      element={(
        <PrivateRoute roles={['Admin']}>
          <RepScorecards workflow />
        </PrivateRoute>
        )}
    />

    <Route
      path="note-count"
      element={(
        <PrivateRoute roles={['Admin']}>
          <NoteCount />
        </PrivateRoute>
        )}
    />

    <Route
      path="unassigned-physicians"
      element={(
        <PrivateRoute roles={['Admin']}>
          <UnassignedPhysicians />
        </PrivateRoute>
        )}
    />

    <Route
      path="rep-schedule"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <RepBonus type="schedule" />
        </PrivateRoute>
      )}
    />

    <Route
      path="celmod"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <CelmodReport />
        </PrivateRoute>
      )}
    />

    <Route
      path="report-single"
      element={(
        <PrivateRoute roles={['Admin', 'Health']}>
          <ReportSingle />
        </PrivateRoute>
        )}
    />

    <Route
      path="new-physicians"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <NewPhysician />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-physicians-by-revenue"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Manufacturer Users']}>
          <TopPhysiciansByRevenue />
        </PrivateRoute>
        )}
    />

    <Route
      path="physicians-report"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <PhysicianMedicationReport />
        </PrivateRoute>
        )}
    />

    <Route
      path="medications-report"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <PhysicianMedicationReport mode="by_product" />
        </PrivateRoute>
        )}
    />

    <Route
      path="growth-by-specializations"
      element={(
        <PrivateRoute roles={['Admin']}>
          <GrowthBySpecializations />
        </PrivateRoute>
        )}
    />

    <Route
      path="syncPak-vs-sortPak"
      element={(
        <PrivateRoute roles={['Admin', 'Health']}>
          <SyncPakVsSortPak />
        </PrivateRoute>
        )}
    />

    <Route
      path="autofill-data"
      element={(
        <PrivateRoute roles={['Admin', 'Physician', 'Health']}>
          <AutoRefillData />
        </PrivateRoute>
        )}
    />

    <Route
      path="patients"
      element={(
        <PrivateRoute roles={['Admin', 'Health']}>
          <DashboardPatients />
        </PrivateRoute>
        )}
    />

    <Route
      path="pipeline"
      element={(
        <PrivateRoute roles={['Admin']}>
          <Pipeline />
        </PrivateRoute>
      )}
    />

    <Route
      path="pipeline-reports"
      element={(
        <PrivateRoute roles={['Admin']}>
          <PipelineReports />
        </PrivateRoute>
      )}
    />

    <Route
      path="top-medications"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health', 'Manufacturer Users']}>
          <TopMedications />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-cities"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health', 'Manufacturer Users']}>
          <TopCities />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-state"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health', 'Manufacturer Users']}>
          <TopStates />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-specializations"
      element={(
        <PrivateRoute roles={['Admin', 'Rep']}>
          <TopSpecializations />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-payors"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health', 'Manufacturer Users']}>
          <TopPayors />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-groups"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Manufacturer Users']}>
          <TopGroups />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-hubs"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Manufacturer Users']}>
          <TopHubs />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-physicians"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Health', 'Manufacturer Users']}>
          <TopPhysicians />
        </PrivateRoute>
        )}
    />

    <Route
      path="top-copay-networks"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Manufacturer Users']}>
          <TopCopayNetworks />
        </PrivateRoute>
        )}
    />

    <Route
      path="revenue-growth-last-month"
      element={(
        <PrivateRoute roles={['Admin', 'Manufacturer Users']}>
          <RevenueGrowthVSLastMonth />
        </PrivateRoute>
        )}
    />

    <Route
      path="revenue-growth-last-year"
      element={(
        <PrivateRoute roles={['Admin', 'Manufacturer Users']}>
          <RevenueGrowthVSLastYear />
        </PrivateRoute>
        )}
    />

    <Route
      path="script-workflow"
      element={(
        <PrivateRoute roles={['Manufacturer Users']}>
          <ScriptWorkflow />
        </PrivateRoute>
        )}
    />
  </Route>
);
